export interface UploadCompleteLocationTrackParams {
  location: string;
  node_type?: 'DIRECTOR_CONSOLE';
}

/** 构造 upload_complete 上传位置参数，导演台只保留一个规范 location 字段。 */
export function getUploadCompleteLocationTrackParams(location?: string): UploadCompleteLocationTrackParams {
  return {
    location: location ?? '',
    ...(location === 'DIRECTOR_CONSOLE' ? { node_type: 'DIRECTOR_CONSOLE' as const } : {}),
  };
}
